import {DomElement,convert2d3d} from '../../types/datatypes'

class VideoElement extends DomElement{
  createDom(){
    var container=this.createContainer()

    var html=`
            <div class="title padding-sm" style="border-color:#fff">`+this.params.name+`</div>
            <video class="value" src="`+this.params.value+`" style="width:`+this.params.width+`px;height:`+this.params.height+`px;"  loop="loop" autoplay="autoplay" />
          `
    container.innerHTML=html
    return container
  }
}

const dom=new VideoElement('video','视频')
dom.params={
  name:'视频',
  value:'',
  width:100,
  height:80,
  use3d:true,
  setting:['namevalue','xyz']
}
dom.format={
  name:{name:'名称',change(mesh,v){
    mesh.element.querySelector('.title').innerHTML=v
  }},
  value:{name:'视频地址',change(mesh,v){
    mesh.element.querySelector('.value').setAttribute('src',v)
  }},
  width:{name:'宽',domtype:'number',change(mesh,v){
    mesh.element.querySelector('.value').style.width=v+'px'
  }},
  height:{name:'高',domtype:'number',change(mesh,v){
    mesh.element.querySelector('.value').style.height=v+'px'
  }},
   use3d:{name:'3d对象',domtype:'switch',change(mesh,v){
             convert2d3d(mesh,v)
          }}
}
export default dom
